import React from "react";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Services from "@/components/Services";
import WhyChooseUs from "@/components/WhyChooseUs";
import CTABanner from "@/components/CTABanner";
import Contact from "@/components/Contact";

export default function HomePage() {
  return (
    <div data-testid="page-home">
      <Hero />
      <About />
      <Services />
      <WhyChooseUs />
      <CTABanner />
      <Contact />
    </div>
  );
}
